// @flow

import clsx from 'clsx';
import * as React from 'react';
import { useAppSelector } from 'src/hooks/useAppSelector';
import { compose } from 'redux';

import { Intro } from 'gandi.react-public-layout';

import { withPageMeta } from '@gandi/app-runner/dist/utils/withPageMeta';
import { selectFromConfig } from '@gandi/redux-config';
import { mapTags, useTranslator } from '@gandi/translate';
import { Base, Button } from '@gandi/ui';

import { withRouter, type WithRouterProps } from 'src/helpers/withRouter';

import defaultLayoutUrls from 'src/helpers/variables';
import Layout from '../containers/Layout';
import { selectInfosUnsubscription } from './modules';
import styles from './Unsubscription.scss';
import type { FullState } from '../types';

export type Props = {|
  ...WithRouterProps<{|
    token: string,
  |}>,
|};

const selectLayoutUrls: FullState => {| +[string]: string |} = selectFromConfig(
  'app.layout.urls',
  defaultLayoutUrls
);

function Unsubscription({ location }: Props): React.Element<typeof Layout> {
  const { __ } = useTranslator();

  const infos = useAppSelector(selectInfosUnsubscription);

  const layoutUrls = useAppSelector(selectLayoutUrls);
  const publicSite = layoutUrls.public_site;
  const dashboardSite = `${layoutUrls.admin}/dashboard`;
  const blogSite = layoutUrls.news;

  const missingInfos =
    (!infos.label && !infos.subscription_key) || !infos.address;

  return (
    <Layout location={location}>
      <Base className={clsx('wrapper-sm', styles.center)}>
        <Intro title={__('Successfully unsubscribed!')} />

        <Base backgroundColor="white" marginBottom="base" padding="small">
          <Base tagName="p" marginY="none">
            {!missingInfos
              ? mapTags(
                  __(
                    '[[email:]] will not receive these email notifications: %(type)s.',
                    {
                      type: infos.label || infos.subscription_key,
                    }
                  ),
                  () => ({
                    email: <strong>{infos.address}</strong>,
                  })
                )
              : __('You will not receive these email notifications.')}
            <br />
            {__(
              'Do you already miss these notifications? Don’t worry, you can still subscribe to them again if you wish.'
            )}
          </Base>
        </Base>
        <Base tagName="h2" marginBottom="base">
          {__('You can resume your normal activities:')}
        </Base>
        <Base marginBottom="base" flexWrap flex gap="small">
          <Button href={dashboardSite}>{__('My dashboard')}</Button>
          <Button href={publicSite} kind="outline">
            {__('Gandi’s homepage')}
          </Button>
          <Button href={blogSite} kind="ghost">
            {__('Read Gandi’s blog')}
          </Button>
        </Base>
      </Base>
    </Layout>
  );
}

export default (compose(
  // $FlowFixMe[underconstrained-implicit-instantiation]
  withRouter,
  withPageMeta(({ __ }) => ({
    title: __('Successfully unsubscribed! - Gandi.net'),
    robots: 'noindex',
  }))
)(Unsubscription): React.ComponentType<{ ... }>);
